export const formatFileSize = (bytes: number): string => {
  if (bytes < 1_024) {
    return `${String(bytes)} B`;
  }

  if (bytes < 1_024 * 1_024) {
    return `${(bytes / 1_024).toFixed(1)} Ko`;
  }

  return `${(bytes / (1_024 * 1_024)).toFixed(1)} Mo`;
};
